var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6083_11587)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 34.4125,
    stroke: "#314064",
    strokeWidth: 2.175
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 68C55.2401 68 68 55.2401 68 39.5C68 23.7599 55.2401 11 39.5 11C23.7599 11 11 23.7599 11 39.5",
    stroke: "#799DD2",
    strokeWidth: 2.175,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0237 37.357C50 36.3807 50 34.8094 50 31.6667C50 28.524 50 26.9526 49.0237 25.9763M49.0237 37.357C48.0474 38.3333 46.476 38.3333 43.3333 38.3333H36.6667C33.524 38.3333 31.9526 38.3333 30.9763 37.357M49.0237 37.357C49.0237 37.357 49.0237 37.357 49.0237 37.357ZM49.0237 25.9763C48.0474 25 46.476 25 43.3333 25L36.6667 25C33.524 25 31.9526 25 30.9763 25.9763M49.0237 25.9763C49.0237 25.9763 49.0237 25.9763 49.0237 25.9763ZM30.9763 25.9763C30 26.9526 30 28.524 30 31.6667C30 34.8094 30 36.3807 30.9763 37.357M30.9763 25.9763C30.9763 25.9763 30.9763 25.9763 30.9763 25.9763ZM30.9763 37.357C30.9763 37.357 30.9763 37.357 30.9763 37.357Z",
    stroke: "#314064",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6663 31.6667C41.6663 32.5871 40.9201 33.3333 39.9997 33.3333C39.0792 33.3333 38.333 32.5871 38.333 31.6667C38.333 30.7462 39.0792 30 39.9997 30C40.9201 30 41.6663 30.7462 41.6663 31.6667Z",
    stroke: "#314064",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 30C47.2386 30 45 27.7614 45 25",
    stroke: "#314064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 33.3333C47.2386 33.3333 45 35.5719 45 38.3333",
    stroke: "#314064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 30C32.7614 30 35 27.7614 35 25",
    stroke: "#314064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 33.3333C32.7614 33.3333 35 35.5719 35 38.3333",
    stroke: "#314064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.333 53.9806H32.0996C33.7843 53.9806 35.4872 54.1562 37.1269 54.494C40.0273 55.0915 43.0811 55.1639 46.0113 54.6896C47.456 54.4557 48.8764 54.0981 50.1621 53.4775C51.3228 52.9173 52.7446 52.1277 53.6996 51.2432C54.6532 50.36 55.6463 48.9145 56.3512 47.7846C56.9557 46.8157 56.6633 45.627 55.7072 44.9051C54.6452 44.1032 53.0692 44.1033 52.0074 44.9054L48.9954 47.1807C47.8281 48.0625 46.553 48.8742 45.034 49.1165C44.8513 49.1456 44.66 49.1722 44.4603 49.1953M44.4603 49.1953C44.4002 49.2023 44.3393 49.2089 44.2777 49.2153M44.4603 49.1953C44.7033 49.1432 44.9446 48.9934 45.1709 48.7958C46.2429 47.8602 46.3107 46.2833 45.3806 45.2385C45.1648 44.9961 44.9122 44.794 44.6314 44.6265C39.9692 41.8457 32.7154 43.9637 28.333 47.0715M44.4603 49.1953C44.3994 49.2084 44.3385 49.2153 44.2777 49.2153M44.2777 49.2153C43.4054 49.3048 42.3849 49.328 41.2526 49.221",
    stroke: "#314064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.333,
    y: 43.3333,
    width: 5,
    height: 13.3333,
    rx: 1.5,
    stroke: "#314064",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6083_11587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalLogo);
export default __webpack_public_path__ + "static/media/modalLogo.91be73c2d8d98ae67f07695919d04f10.svg";
export { ForwardRef as ReactComponent };